/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class PaymentHookService {

    /**
     * Process event from stripe
     * @returns any Successful response
     * @throws ApiError
     */
    public static paymentHookControllerProcessEventFromStripe(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/payment-hook/stripe-hook',
        });
    }

}
